export enum CHAT_AGENT_STATUS {
  NOT_READY = 1,
  READY = 2
}
